import { Component, Input, OnInit } from '@angular/core';
import { Fases, Petition, Process } from 'src/app/interfaces/interfaces.index';
import { FASES } from '../config/config';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css']
})
export class StepperComponent implements OnInit {

  @Input() fase: number;
  @Input() petition: Petition;
  @Input() procesos: Process[] = [];
  phase: Fases[] = FASES;

  get activeFases(): Fases[] {
    if (!this.procesos?.length) return this.phase;
    const fasesConPasos = new Set(this.procesos.map(p => p.phase));
    return this.phase.filter(f => fasesConPasos.has(f.number));
  }

  constructor() {}

  ngOnInit() {}
}
